import React from 'react';
interface ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  className?: string;
  onClick?: () => void;
}
export function Button({
  children,
  variant = 'primary',
  className = '',
  onClick
}: ButtonProps) {
  const baseClasses = 'px-4 py-2 rounded-md font-medium transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-opacity-50';
  const variantClasses = {
    primary: 'bg-[#C8F169] text-[#1E2A38] hover:bg-opacity-90 focus:ring-[#C8F169]',
    secondary: 'bg-transparent border border-[#F5F7FA] text-[#F5F7FA] hover:bg-[#F5F7FA] hover:bg-opacity-10 focus:ring-[#F5F7FA]'
  };
  return <button className={`${baseClasses} ${variantClasses[variant]} ${className}`} onClick={onClick} data-id="element-192">
      {children}
    </button>;
}